module.exports = __webpack_public_path__ + "static/media/NYLON 90.0cb6d19a.png";